import aave from './aave.scss';
import aitech from './aitech.scss';
import cryptopugz from './cryptopugz.scss';
import aavegotchi from './aavegotchi.scss';
import achievmintry from './achievmintry.scss';
import acoconutbsc from './acoconutbsc.scss';
import adex from './adex.scss';
import madskullz from './madskullz.scss';
import adventureland from './adventureland.scss';
import agdeportes from './agdeportes.scss';
import airswap from './airswap.scss';
import akropolisDelphi from './akropolis-delphi.scss';
import alchemistdefi from './alchemistdefi.scss';
import alpaca from './alpaca.scss';
import alpha from './alpha.scss';
import choccyswap from './choccyswap.scss';
import altrucoin from './altrucoin.scss';
import amp from './amp.scss';
import ampleforth from './ampleforth.scss';
import anjmol from './anjmol.scss';
import apeswap from './apeswap.scss';
import apetroop from './apetroop.scss';
import apy from './apy.scss';
import aragon from './aragon.scss';
import aragonchina from './aragonchina.scss';
import arckyf from './arckyf.scss';
import mero from './mero.scss';
import badger from './badger.scss';
import bancor from './bancor.scss';
import bake from './bake.scss';
import balancer from './balancer.scss';
import ballena from './ballena.scss';
import bamboodefi from './bamboodefi.scss';
import barnbridge from './barnbridge.scss';
import dmc from './dmc.scss';
import planetmemes from './planetmemes.scss';
import based from './based.scss';
import basedloans from './basedloans.scss';
import bee2 from './bee2.scss';
import benchmark from './benchmark.scss';
import betswirl from './betswirl.scss';
import breederdaoSpace from './breederdao-space.scss';
import blackpink from './blackpink.scss';
import blackpoolhq from './blackpoolhq.scss';
import blockzerolabs from './blockzerolabs.scss';
import bloody from './bloody.scss';
import boostedFinance from './boosted-finance.scss';
import calciumcrew from './calciumcrew.scss';
import capy from './capy.scss';
import cargo from './cargo.scss';
import carrotswap from './carrotswap.scss';
import castelloCommunity from './castello-community.scss';
import chadsvc from './chadsvc.scss';
import chargedParticles from './charged-particles.scss';
import chartex from './chartex.scss';
import clucoin from './clucoin.scss';
import cofix from './cofix.scss';
import coin from './coin.scss';
import coinswap from './coinswap.scss';
import complus from './complus.scss';
import conic from './conic.scss';
import contribute from './contribute.scss';
import cover from './cover.scss';
import cuni from './cuni.scss';
import curve from './curve.scss';
import dalmatians from './dalmatians.scss';
import daniellMesquita from './daniell-mesquita.scss';
import darkmatter from './darkmatter.scss';
import deversifi from './deversifi.scss';
import daosquare from './daosquare.scss';
import dawn from './dawn.scss';
import debaseonomics from './debaseonomics.scss';
import defiat from './defiat.scss';
import depocket from './depocket.scss';
import derivadao from './derivadao.scss';
import dextfprotocol from './dextfprotocol.scss';
import dfi from './dfi.scss';
import dforce from './dforce.scss';
import dfv from './dfv.scss';
import dhedge from './dhedge.scss';
import diadata from './diadata.scss';
import dinoswap from './dinoswap.css';
import dittomoney from './dittomoney.scss';
import dogeswap from './dogeswap.scss';
import domo from './domo.scss';
import dorg from './dorg.scss';
import dracula from './dracula.scss';
import dsgn from './dsgn.scss';
import dsla from './dsla.scss';
import easybake from './easybake.scss';
import egg from './egg.scss';
import elementfinance from './elementfinance.scss';
import emptysetgold from './emptysetgold.scss';
import esprezzo from './esprezzo.scss';
import etgfinance from './etgfinance.scss';
import evoland from './evoland.scss';
import example from './example.scss';
import expectchaos from './expectchaos.scss';
import fairmoon from './fairmoon.scss';
import farm from './farm.scss';
import fei from './fei.scss';
import flamingo from './flamingo.scss';
import flush from './flush.scss';
import fnx from './fnx.scss';
import fortube from './fortube.scss';
import frankendefi from './frankendefi.scss';
import fries from './fries.scss';
import frontier from './frontier.scss';
import galleon from './galleon.scss';
import gamer from './gamer.scss';
import gatenet from './gatenet.scss';
import gem from './gem.scss';
import geneFinance from './gene-finance.scss';
import gitcoin from './gitcoin.scss';
import giveth from './giveth.scss';
import gmt from './gmt.scss';
import gnometoken from './gnometoken.scss';
import gnosis from './gnosis.scss';
import goatcoin from './goatcoin.scss';
import gokai from './gokai.scss';
import golff from './golff.scss';
import grap from './grap.scss';
import greytoken from './greytoken.scss';
import griffin from './griffin.scss';
import halodao from './halodao.scss';
import hifiFinance from './hifi-finance.scss';
import hopr from './hopr.scss';
import hubdao from './hubdao.scss';
import hurricane from './hurricane.scss';
import ilv from './ilv.scss';
import imsuperleague from './imsuperleague.scss';
import index from './index.scss';
import indexed from './indexed.scss';
import ironbank from './ironbank.scss';
import itam from './itam.scss';
import iwan from './iwan.scss';
import iyffinance from './iyffinance.scss';
import jiaozi from './jiaozi.scss';
import julpad from './julpad.scss';
import julswap from './julswap.scss';
import kebabfinance from './kebabfinance.scss';
import keyfi from './keyfi.scss';
import kleros from './kleros.scss';
import kogecoin from './kogecoin.scss';
import kuhoge from './kuhoge.scss';
import lakanInteractive from './lakan-interactive.scss';
import lao from './lao.scss';
import lido from './lido.scss';
import light from './light.scss';
import limitswap from './limitswap.scss';
import liquiddriver from './liquiddriver.scss';
import longterm from './longterm.scss';
import love from './love.scss';
import macaronswap from './macaronswap.scss';
import magicbalancer from './magicbalancer.scss';
import maker from './maker.scss';
import mate from './mate.scss';
import mantraDao from './mantra-dao.scss';
import masknetwork from './masknetwork.scss';
import mee from './mee.scss';
import metacartel from './metacartel.scss';
import metafactory from './metafactory.scss';
import metatopia from './metatopia.scss';
import metfiDao from './metfi-dao.scss';
import mettalex from './mettalex.scss';
import mithcash from './mithcash.scss';
import momentum from './momentum.scss';
import morpho from './morpho.scss';
import moonpotdotcom from './moonpotdotcom.scss';
import moonswap from './moonswap.scss';
import moontools from './moontools.scss';
import moonvault from './moonvault.scss';
import moonwell from './moonwell.scss';
import moonwellApollo from './moonwell-apollo.scss';
import mstable from './mstable.scss';
import multiplier from './multiplier.scss';
import music from './music.scss';
import mybit from './mybit.scss';
import narwhal from './narwhal.scss';
import nation3 from './nation3.scss';
import nest from './nest.scss';
import neverlose from './neverlose.scss';
import nftgoddess from './nftgoddess.scss';
import nice from './nice.scss';
import oaklanddao from './oaklanddao.scss';
import oceandao from './oceandao.scss';
import octofi from './octofi.scss';
import omg from './omg.scss';
import origin from "./origin.scss";
import paladin from './paladin.scss';
import pancake from './pancake.scss';
import pandayield from './pandayield.scss';
import penguinParty from './penguin-party.scss';
import pickle from './pickle.scss';
import piedao from './piedao.scss';
import plantswap from './plantswap.scss';
import poh from './poh.scss';
import pok from './pok.scss';
import poktNetwork from './pokt-network.scss';
import polyientGamesGovernance from './polyient-games-governance.scss';
import pooltogether from './pooltogether.scss';
import potion from './potion.scss';
import premia from './premia.scss';
import prepo from './prepo.scss';
import primitive from './primitive.scss';
import pupperdao from './pupperdao.scss';
import pye from './pye.scss';
import qian from './qian.scss';
import qubcoins from './qubcoins.scss';
import raidGuild from './raid-guild.scss';
import rari from './rari.scss';
import rhino from './rhino.scss';
import rope from './rope.scss';
import rot from './rot.scss';
import safe from './safe.scss';
import sake from './sake.scss';
import santiment from './santiment.scss';
import sav3 from './sav3.scss';
import self from './self.scss';
import shabushabu from './shabushabu.scss';
import shapeshift from './shapeshift.scss';
import shardcoin from './shardcoin.scss';
import shilldao from './shilldao.scss';
import shrimp from './shrimp.scss';
import shroom from './shroom.scss';
import six from './six.scss';
import sleeping from './sleeping.scss';
import smartdexVoting from './smartdex-voting.scss';
import smol from './smol.scss';
import smoothyfinance from './smoothyfinance.scss';
import southchain from './southchain.scss';
import spaceswap from './spaceswap.scss';
import spaghetti from './spaghetti.scss';
import spicedao from './spicedao.scss';
import spiderdao from './spiderdao.scss';
import spooky from './spooky.scss';
import sporkdao from './sporkdao.scss';
import aurigamiFinance from './aurigami-finance.scss';
import sportx from './sportx.scss';
import squirrelcash from './squirrelcash.scss';
import stakedao from './stakedao.scss';
import stakewise from './stakewise.scss';
import status from './status.scss';
import steakbank from './steakbank.scss';
import streamr from './streamr.scss';
import taraxa from './taraxa.scss';
import sushi from './sushi.scss';
import sushipowah from './sushipowah.scss';
import swagg from './swagg.scss';
import swaphub from './swaphub.scss';
import swapx from './swapx.scss';
import swarm from './swarm.scss';
import swerve from './swerve.scss';
import synthetix from './synthetix.scss';
import takeprofit from './takeprofit.scss';
import tballiance from './tballiance.scss';
import thelao from './thelao.scss';
import thirm from './thirm.scss';
import radiant from './radiant.scss';
import totemearth from './totemearth.scss';
import tracer from './tracer.scss';
import treasuredao from './treasuredao.scss';
import tripscommunity from './tripscommunity.scss';
import trustwallet from './trustwallet.scss';
import tw33t from './tw33t.scss';
import uma from './uma.scss';
import unfederalreserve from './unfederalreserve.scss';
import unicore from './unicore.scss';
import unidao from './unidao.scss';
import uniswap from './uniswap.scss';
import unitprotocol from './unitprotocol.scss';
import universe from './universe.scss';
import velotoken from './velotoken.scss';
import visor from './visor.scss';
import votewarp from './votewarp.scss';
import wassies from './wassies.scss';
import web3Api from './web3-api.scss';
import wolfdefi from './wolfdefi.scss';
import xpunks from './xpunks.scss';
import y3d from './y3d.scss';
import yakuza from './yakuza.scss';
import yam from './yam.scss';
import yamv2 from './yamv2.scss';
import yashadao from './yashadao.scss';
import yaxis from './yaxis.scss';
import yearn from './yearn.scss';
import yfarm from './yfarm.scss';
import yffc from './yffc.scss';
import yffs from './yffs.scss';
import yflink from './yflink.scss';
import ymen from './ymen.scss';
import yup from './yup.scss';
import zeta from './zeta.scss';
import zlot from './zlot.scss';
import zoocoin from './zoocoin.scss';
import cyberkongz from './cyberkongz.scss';
import moonbeans from './moonbeans.scss';
import yesports from './yesports.scss';
import forward from './forward.scss';
import artizen from './artizen.scss';
import dewo from './dewo.scss';
import breederdao from './breederdao.scss';
import bgldao from './bgldao.scss';
import gogoprotocol from './gogoprotocol.scss';
import thekapitaldao from './thekapitaldao.scss';
import infinex from './infinex.scss';

export default {
  aave,
  aitech,
  cryptopugz,
  aavegotchi,
  achievmintry,
  acoconutbsc,
  adex,
  madskullz,
  adventureland,
  agdeportes,
  airswap,
  'akropolis-delphi': akropolisDelphi,
  alchemistdefi,
  alpaca,
  alpha,
  altrucoin,
  amp,
  ampleforth,
  anjmol,
  apeswap,
  apetroop,
  apy,
  aragon,
  aragonchina,
  arckyf,
  mero,
  badger,
  dmc,
  bake,
  balancer,
  ballena,
  bamboodefi,
  bancor,
  barnbridge,
  based,
  basedloans,
  bee2,
  benchmark,
  betswirl,
  'breederdao-space': breederdaoSpace,
  blackpink,
  planetmemes,
  blackpoolhq,
  blockzerolabs,
  bloody,
  'boosted-finance': boostedFinance,
  calciumcrew,
  capy,
  cargo,
  carrotswap,
  'castello-community': castelloCommunity,
  chadsvc,
  'charged-particles': chargedParticles,
  chartex,
  choccyswap,
  clucoin,
  cofix,
  coin,
  coinswap,
  complus,
  contribute,
  cover,
  conic,
  cuni,
  curve,
  cyberkongz,
  dalmatians,
  'daniell-mesquita': daniellMesquita,
  darkmatter,
  daosquare,
  dawn,
  debaseonomics,
  defiat,
  depocket,
  derivadao,
  deversifi,
  dextfprotocol,
  dfi,
  dforce,
  dfv,
  dhedge,
  diadata,
  dinoswap,
  dittomoney,
  dogeswap,
  domo,
  dorg,
  dracula,
  dsgn,
  dsla,
  easybake,
  egg,
  elementfinance,
  emptysetgold,
  esprezzo,
  etgfinance,
  evoland,
  example,
  expectchaos,
  fairmoon,
  farm,
  fei,
  flamingo,
  flush,
  forward,
  fnx,
  fortube,
  frankendefi,
  fries,
  frontier,
  galleon,
  gamer,
  gatenet,
  gem,
  'gene-finance': geneFinance,
  gitcoin,
  giveth,
  gmt,
  gnometoken,
  gnosis,
  goatcoin,
  gokai,
  golff,
  grap,
  greytoken,
  griffin,
  halodao,
  'hifi-finance': hifiFinance,
  hopr,
  hubdao,
  hurricane,
  ilv,
  imsuperleague,
  index,
  indexed,
  ironbank,
  itam,
  iwan,
  iyffinance,
  jiaozi,
  julpad,
  julswap,
  kebabfinance,
  keyfi,
  kleros,
  kogecoin,
  kuhoge,
  'lakan-interactive': lakanInteractive,
  lao,
  lido,
  light,
  limitswap,
  liquiddriver,
  longterm,
  love,
  macaronswap,
  magicbalancer,
  maker,
  mate,
  'mantra-dao': mantraDao,
  masknetwork,
  mee,
  metacartel,
  metafactory,
  metatopia,
  'metfi-dao': metfiDao,
  mettalex,
  mithcash,
  momentum,
  morpho,
  moonbeans,
  moonpotdotcom,
  moonswap,
  moontools,
  moonvault,
  moonwell,
  'moonwell-apollo': moonwellApollo,
  mstable,
  multiplier,
  music,
  mybit,
  narwhal,
  nation3,
  nest,
  neverlose,
  nftgoddess,
  nice,
  oaklanddao,
  oceandao,
  octofi,
  omg,
  origin,
  paladin,
  pancake,
  pandayield,
  'penguin-party': penguinParty,
  pickle,
  piedao,
  plantswap,
  poh,
  pok,
  'pokt-network': poktNetwork,
  'polyient-games-governance': polyientGamesGovernance,
  pooltogether,
  potion,
  premia,
  prepo,
  primitive,
  pupperdao,
  pye,
  qian,
  qubcoins,
  radiant,
  'raid-guild': raidGuild,
  rari,
  rhino,
  rope,
  rot,
  safe,
  sake,
  santiment,
  sav3,
  self,
  shabushabu,
  shapeshift,
  shardcoin,
  shilldao,
  shrimp,
  shroom,
  six,
  sleeping,
  'smartdex-voting': smartdexVoting,
  smol,
  smoothyfinance,
  southchain,
  spaceswap,
  spaghetti,
  spicedao,
  spiderdao,
  spooky,
  'aurigami-finance': aurigamiFinance,
  sporkdao,
  sportx,
  squirrelcash,
  stakedao,
  stakewise,
  status,
  steakbank,
  streamr,
  sushi,
  taraxa,
  sushipowah,
  swagg,
  swaphub,
  swapx,
  swarm,
  swerve,
  synthetix,
  takeprofit,
  tballiance,
  thelao,
  thirm,
  totemearth,
  tracer,
  treasuredao,
  tripscommunity,
  trustwallet,
  tw33t,
  uma,
  unfederalreserve,
  unicore,
  unidao,
  uniswap,
  unitprotocol,
  universe,
  velotoken,
  visor,
  votewarp,
  wassies,
  'web3-api': web3Api,
  wolfdefi,
  xpunks,
  y3d,
  yakuza,
  yam,
  yamv2,
  yashadao,
  yaxis,
  yearn,
  yesports,
  yfarm,
  yffc,
  yffs,
  yflink,
  ymen,
  yup,
  zeta,
  zlot,
  zoocoin,
  artizen,
  dewo,
  gogoprotocol,
  bgldao,
  breederdao,
  thekapitaldao,
  infinex
};
